var map = {
	"./images/nulltx.png": 1815
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1814;


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/media ^.*\/nulltx\.png$
// module id = 1814
// module chunks = 147